import i18nFactory from '@yandex-int/i18n';

import { Lang, Tld } from '../../typings/common';
import { LangUtils } from '../Lang/Lang';
import { UrlHelpers } from '../UrlHelpers';

import * as keyset from './LangSwitcher.i18n';
const i18n = i18nFactory(keyset);

export interface LangSwitchInfo {
    url: string;
    label: string;
}

export function getLangSwitchInfo(retPath: string, tuneSecretKey: string): LangSwitchInfo {
    const tld = UrlHelpers.getTld();
    const langSwitchInfo: Record<Lang, { lang: Lang; label: string }> = {
        [Lang.ru]: { lang: Lang.en, label: i18n('switch-to-english') },
        [Lang.uk]: { lang: Lang.ru, label: i18n('switch-to-russian') },
        [Lang.en]:
            tld === Tld.comTr
                ? { lang: Lang.tr, label: i18n('switch-to-turkish') }
                : { lang: Lang.ru, label: i18n('switch-to-russian') },
        [Lang.tr]: { lang: Lang.en, label: i18n('switch-to-english') }
    };

    const { lang, label } = langSwitchInfo[LangUtils.getCurrentLang()];

    const url = `https://www.yandex.${UrlHelpers.getTld()}/portal/set/lang/?retpath=${encodeURIComponent(
        retPath
    )}&intl=${lang}&sk=${tuneSecretKey}`;

    return {
        url,
        label
    };
}
